export type InstrumentCode = string;

export enum OptionType {
  All = 'All',
  Call = 'Call',
  Put = 'Put'
}

export enum OptionStyle {
  American = 'American',
  European = 'European',
  Asian = 'Asian'
}

export enum NewsIndicatorType {
  BlogNews = 'BlogNews',
  MarketSensitive = 'MarketSensitive',
  MarketInsensitive = 'MarketInsensitive'
}

export interface IOptionDetail {
  expiryDate: number;
  type: OptionType;
  style: OptionStyle;
  strikePrice: number;
  contractSize: number;
}

export interface IEquityDetail {
  sector: string;
  industryGroup: string;
}

export interface IMFundDetail {
  issuer: string;
  launchDate: number;
  pdsIssueDate: number;
  pdsUrl: string;
  pdsProfileUrl: string;
}

export interface IIrsDetail {
  maturityDate: number;
  couponRate: number;
  couponFrequency: string;
  faceValue: number;
  couponDate: number;
}

export interface IWarrantDetail {
  type: string;
  expiry: number;
  issuer: string;
  series: string;
  strikePrice: number;
  strikePriceUnit: number;
}

export enum InstrumentClass {
  Unknown = 'Unknown',
  Equity = 'Equity',
  InterestRate = 'InterestRate',
  Option = 'Option',
  Warrant = 'Warrant',
  Index = 'Index',
  Etp = 'Etp',
  MFund = 'MFund',
  TraCR = 'TraCR',
  Combo = 'Combo',
  Crypto = 'Crypto'
}

export interface IInstrumentDetail {
  instrument: InstrumentCode;
  exchangeId: string;
  name?: string; // ShortDescription
  longName?: string;
  underlyingCode: string;
  class: InstrumentClass;
  companyName: string;
  tradeable: boolean;
  country?: string;
  fullDetail: boolean;
  sector?: string;

  option?: IOptionDetail;
  equity?: IEquityDetail;
  mfund?: IMFundDetail;
  warrant?: IWarrantDetail;
  irs?: IIrsDetail;
}

export interface IDividends {
  instrument: string;
  companyName?: string;
  exDividendDate?: number;
  dividendPayDate?: number;
  amount?: number;
  franking?: number;
}

export interface IDividendsResponse {
  'ASX Code': string;
  'Company Name'?: string;
  'Ex Dividend Date'?: string;
  'Dividend Pay Date'?: string;
  Amount?: string;
  Franking?: string;
}

export interface INews {
  indicatorType: NewsIndicatorType;
  heading: string;
  releaseDate: number;
  instrument: string;
}

export interface IEsgData {
  productInvolvements?: string[];
  controversies?: string[];
  esgRiskScore?: number;
  environmentRiskScore?: number;
  socialRiskScore?: number;
  governanceRiskScore?: number;
  esgRiskCategory?: string;
  highestControversyLevelAnswerCategory?: number;
  highestControversyLevelCategory?: string;
  extractionDate?: Date | string;
}

export interface IEsgDataResponse {
  isSuccess: boolean;
  errorMessage?: string;
  esgData?: IEsgData;
}
